var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container bairun-purchase-check-add" },
    [
      _c(
        "div",
        [
          _c("span", { staticClass: "divider-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _c("el-divider")
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 24 : 16 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "add-form",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "油站：" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "搜索条件"
                                  },
                                  on: { change: _vm.onChangeStation },
                                  model: {
                                    value: _vm.formData.stationId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "stationId", $$v)
                                    },
                                    expression: "formData.stationId"
                                  }
                                },
                                _vm._l(_vm.asyncStations, function(item) {
                                  return _c("el-option", {
                                    key: item.ID,
                                    attrs: {
                                      label: item.stationName,
                                      value: item.ID
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.rows, stripe: "", border: "" }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "所属期" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-date-picker", {
                                          attrs: {
                                            type: "date",
                                            format: "yyyy-MM-dd",
                                            "value-format": "yyyy-MM-dd",
                                            placeholder: "日期选择",
                                            clearable: false
                                          },
                                          model: {
                                            value: scope.row.dailyDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "dailyDate",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.dailyDate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { label: "油品" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              clearable: "",
                                              placeholder: "选择油品"
                                            },
                                            model: {
                                              value: scope.row.oilCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "oilCode",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.oilCode"
                                            }
                                          },
                                          _vm._l(_vm.oilCodeMap, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item,
                                              attrs: {
                                                label: "#" + item,
                                                value: item
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { label: "进油吨数" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请输入",
                                            min: 0,
                                            controls: false
                                          },
                                          model: {
                                            value: scope.row.totalGiveInTon,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "totalGiveInTon",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.totalGiveInTon"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { label: "进油升数" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请输入",
                                            min: 0,
                                            controls: false
                                          },
                                          model: {
                                            value: scope.row.totalGiveInLiters,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "totalGiveInLiters",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.totalGiveInLiters"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c(
                                "el-table-column",
                                {
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "danger" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onDelRow(
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("删除")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.onAddRow }
                                        },
                                        [_vm._v("新增")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bairun-bottom-tool" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function() {
                  _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _c("el-button", { on: { click: _vm.onClear } }, [_vm._v("清空")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }